import Button from "@material-ui/core/Button";
import React from "react";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useFunctions } from "reactfire";
import { useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";

const stripePromise = loadStripe(
  "pk_test_51HMsL8CDHyyr7rmfcDjDVyyYYIzSrKzzWmIbY5JW8Q782AWkGqGpqgpi1rqCEzkz1tFjERGS8AfWBpwAK7l9FWxE005wujBKrQ"
);

function TicketReservationPayButton() {
  const functions = useFunctions();
  const query = useQuery();

  const createCheckout = functions.httpsCallable("createCheckout");

  const handleClick = async () => {
    // Get Stripe.js instance
    const stripe = await stripePromise;

    // Call your backend to create the Checkout Session
    const response = await createCheckout().catch((error) => {
      console.error(error);
    });

    if (
      response == null ||
      response.data == null ||
      response.data.sessionId == null
    ) {
      console.error("Session ID is not valid", response);
      return;
    }

    const {
      data: { sessionId },
    } = response;

    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: sessionId,
    });

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
      console.error(result.error);
      alert(result.error.message);
    }
  };

  const status = query.get("pay");

  return (
    <>
      <Button variant="contained" onClick={handleClick} color="secondary">
        Testkauf tätigen
      </Button>
      {status != null && <Typography>Deine Zahlung war: {status}</Typography>}
    </>
  );
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default TicketReservationPayButton;
